(function () {
  'use strict';
  const version = '2026-10-10-compact-1';
  if (window.BMGLatestCompact?.version === version) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  const clamp = value => Math.max(0, Math.min(1, value));
  const mix = (a, b, p) => a + (b - a) * p;
  const ease = (a, b, value) => { const p = clamp((value - a) / (b - a)); return p * p * (3 - 2 * p); };
  function mount(root) {
    if (instances.has(root) || root.dataset.motion !== 'true' || preference.matches) return;
    const config = document.querySelector('[data-bmg-v2-config]');
    if (!config || config.dataset.motion === 'false') return;
    const viewport = root.querySelector('[data-compact-viewport]');
    const world = root.querySelector('[data-compact-world]');
    const art = root.querySelector('[data-compact-art]');
    const photo = root.querySelector('.bmg-latest-motion__image');
    const room = root.querySelector('.bmg-latest-motion__room');
    const mat = root.querySelector('[data-compact-mat]');
    const shadow = root.querySelector('[data-compact-shadow]');
    const hint = root.querySelector('[data-compact-hint]');
    const note = root.querySelector('[data-compact-note]');
    const edges = ['top','right','bottom','left'].map(side => root.querySelector('[data-compact-edge="' + side + '"]'));
    if (!viewport || !world || !art || !photo || !room || !mat || !shadow || edges.some(edge => !edge)) return;
    const abort = new AbortController();
    const on = (target, event, callback, options = {}) => target.addEventListener(event, callback, {...options, signal:abort.signal});
    let dimensions, frame = 0, active = true, intersection, resize;
    function render() {
      frame = 0;
      if (!dimensions || !active) return;
      const {width,height,worldWidth,worldHeight,artX,artY,startScale} = dimensions;
      const rect = viewport.getBoundingClientRect();
      const vh = document.documentElement.clientHeight || innerHeight;
      const startAt = Math.max(vh * .5, vh - height + 24);
      const endAt = Math.max(24, Math.min(100, vh * .12));
      const p = clamp((startAt - rect.top) / Math.max(1, startAt - endAt));
      const roomProgress = ease(.53, .98, p);
      const framedScale = mix(startScale, startScale * .82, ease(.04, .22, p));
      const scale = mix(framedScale, 1, roomProgress);
      const centreY = mix(height * .5, height * .36, roomProgress);
      world.style.transform = 'translate3d(' + (width/2-artX*scale).toFixed(2) + 'px,' + (centreY-artY*scale).toFixed(2) + 'px,0) scale(' + scale.toFixed(5) + ')';
      room.style.opacity = ease(.53, .79, p).toFixed(4);
      mat.style.opacity = ease(.13, .31, p).toFixed(4);
      shadow.style.opacity = ease(.42, .66, p).toFixed(4);
      edges.forEach((edge, index) => {
        const progress = ease(.16 + index*.06, .33 + index*.06, p);
        edge.style.transform = (index%2 ? 'scaleY(' : 'scaleX(') + progress.toFixed(5) + ')';
        edge.style.opacity = progress > 0 ? '1' : '0';
      });
      if (hint) hint.style.opacity = (1-ease(.78, .96, p)).toFixed(4);
      if (note) note.style.opacity = ease(.82, .98, p).toFixed(4);
    }
    function measure() {
      frame = 0;
      if (!room.complete || !room.naturalWidth || !photo.complete || !photo.naturalWidth) return;
      const width = viewport.clientWidth, height = viewport.clientHeight;
      if (width <= 0 || height <= 0) return;
      const ratio = Math.max(.25, Number(root.dataset.ratio) || photo.naturalWidth/photo.naturalHeight || 3);
      const worldWidth = Math.max(width, height*1.6), worldHeight = worldWidth/1.6;
      const artWidth = Math.min(worldWidth*.55, height*.53*ratio);
      const artHeight = artWidth/ratio;
      dimensions = {width,height,worldWidth,worldHeight,artX:worldWidth*.52,artY:worldHeight*.51-artHeight/2,startScale:Math.min(width,height*ratio)/artWidth};
      root.style.setProperty('--compact-frame', Math.max(2.5,Math.min(8,worldWidth*.0048)) + 'px');
      root.style.setProperty('--compact-mat', Math.max(3.5,Math.min(12,worldWidth*.007)) + 'px');
      world.style.width = worldWidth + 'px';
      world.style.height = worldHeight + 'px';
      art.style.width = artWidth + 'px';
      root.setAttribute('data-compact-ready','');
      render();
    }
    const tick = () => { if (active && !frame) frame = requestAnimationFrame(render); };
    const remeasure = () => { cancelAnimationFrame(frame); frame=requestAnimationFrame(measure); };
    function destroy() {
      abort.abort(); intersection?.disconnect(); resize?.disconnect(); cancelAnimationFrame(frame);
      root.removeAttribute('data-compact-ready');
      ['--compact-frame','--compact-mat'].forEach(name=>root.style.removeProperty(name));
      [world,art,room,mat,shadow,hint,note,...edges].forEach(element=>element?.removeAttribute('style'));
      instances.delete(root);
    }
    instances.set(root,destroy);
    on(window,'scroll',tick,{passive:true});
    on(window,'resize',remeasure,{passive:true});
    on(room,'load',remeasure); on(photo,'load',remeasure);
    on(room,'error',destroy); on(photo,'error',destroy);
    if ('ResizeObserver' in window) { resize = new ResizeObserver(remeasure); resize.observe(viewport); }
    if ('IntersectionObserver' in window) {
      intersection = new IntersectionObserver(entries=>{active=entries.some(entry=>entry.isIntersecting);if(active)remeasure();},{rootMargin:'40% 0px'});
      intersection.observe(viewport);
    }
    measure();
  }
  function init() { document.querySelectorAll('[data-bmg-compact]').forEach(mount); }
  const restart = () => { [...instances.values()].forEach(destroy=>destroy()); init(); };
  preference.addEventListener('change',restart);
  document.addEventListener('shopify:section:load',restart);
  document.addEventListener('shopify:section:unload',event=>{[...instances.entries()].forEach(([root,destroy])=>{if(event.target.contains(root))destroy();});});
  window.addEventListener('pageshow',restart);
  window.BMGLatestCompact = {version,init};
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
